<template>
    <ul>
        <router-link v-if="(position !== 'right')&&can('project.view')" key="project.view" :to="{ name: 'project.list'}" tag="li" active-class="uk-active" :class="{'uk-parent': can('project.view')}" :data-uk-dropdown="can('project.create')" exact>
            <a href="#">Projects</a>

            <div v-if="can('project.create')" class="uk-dropdown uk-dropdown-navbar">
                <ul class="uk-nav uk-nav-navbar">
                    <li>
                        <a href @click.prevent="$emit('new-project', 'overhead_project')">New Overhead Project</a>
                    </li>
                </ul>
            </div>
        </router-link>
        <router-link v-if="(position !== 'right')&&can('prospective_project.view')" key="prospective_project.view" :to="{ name: 'prospective_project.list'}" tag="li" active-class="uk-active" :class="{'uk-parent': can('prospective_project.view')}" :data-uk-dropdown="can('prospective_project.create')" exact>
            <a href="#">Prospective Projects</a>

            <!--
            <div v-if="can('prospective_project.create')" class="uk-dropdown uk-dropdown-navbar">
                <ul class="uk-nav uk-nav-navbar">
                    <li>
                        <a href @click.prevent="$emit('new-project', 'project')">New Prospective Project</a>
                    </li>
                </ul>
            </div>
            //-->
        </router-link>
        <router-link v-if="(position !== 'right')&&can('project_request.view')" key="project_request.view" :to="{ name: 'project_request.list'}" tag="li" active-class="uk-active" exact>
            <a href="#">RFP</a>
        </router-link>
        <router-link v-if="(position !== 'right')&&can('user.view')" key="user.view" :to="{ name: 'user.list'}" tag="li" active-class="uk-active" :class="{'uk-parent': can('user.view')}" :data-uk-dropdown="is_db_admin_active&&can('user.create')" exact>
            <a href="#">Staff</a>

            <div v-if="is_db_admin_active&&can('user.create')" class="uk-dropdown uk-dropdown-navbar">
                <ul class="uk-nav uk-nav-navbar">
                    <li>
                        <a href @click.prevent="$emit('new-user', 'user')">New Staff Member</a>
                    </li>
                </ul>
            </div>
        </router-link>
        <router-link v-if="(position !== 'right')&&can('firm.view')" key="firm.view" :to="{ name: 'firm.list'}" tag="li" active-class="uk-active" :class="{'uk-parent': can('firm.view')}" :data-uk-dropdown="can('firm.create')" exact>
            <a href="#">Firms</a>

            <div v-if="can('firm.create')" class="uk-dropdown uk-dropdown-navbar">
                <ul class="uk-nav uk-nav-navbar">
                    <li>
                        <a href @click.prevent="create_record('firm')">New Firm</a>
                    </li>
                </ul>
            </div>
        </router-link>
        <router-link v-if="(position !== 'right')&&can('contact.view')" key="contact.view" :to="{ name: 'contact.list'}" tag="li" active-class="uk-active" :class="{'uk-parent': can('contact.view')}" :data-uk-dropdown="can('contact.create')" exact>
            <a href="#">Contacts</a>

            <div v-if="can('contact.create')" class="uk-dropdown uk-dropdown-navbar">
                <ul class="uk-nav uk-nav-navbar">
                    <li>
                        <a href @click.prevent="$emit('new-contact', 'contact')">New Contact</a>
                    </li>
                </ul>
            </div>
        </router-link>
        <router-link v-if="!!profile_id&&(position !== 'right')" key="reports" :to="{ name: 'reports'}" tag="li" active-class="uk-active" exact><a href="#">Reports</a></router-link>
        <router-link v-if="(position !== 'right') && is_settings_admin" key="settings" :to="{ name: 'settings'}" tag="li" active-class="uk-active" exact><a href="#">Settings</a></router-link>

        <li v-if="!!profile_id&&(position === 'right')" class="uk-vertical-align lam-nav-search">
            <form class="uk-form uk-margin-remove uk-vertical-align-middle" @submit.prevent="query">
                <div class="uk-flex uk-width-1-1 lam-button-group-field uk-active">
                    <div class="uk-button uk-form-select" data-uk-form-select>
                        Search {{ current_search_entity }} <open-icon glyph="caret-down" />
                        <select v-model="search_entity" @change="changed_search_entity">
                            <option
                                v-for="search_entity in search_entities"
                                :key="search_entity.id"
                                :value="search_entity.id"
                            >
                                {{ search_entity.name }}
                            </option>
                        </select>
                    </div>
                    <input ref="searchbox" v-shortkey.focus="{'pc': ['ctrl', 'f'], 'mac': ['meta', 'f']}" type="text" v-model="search" placeholder="Search">
                    <button type="submit" @click.prevent="query" class="uk-button uk-button-primary">
                        <open-icon glyph="search" />
                    </button>
                </div>
            </form>
        </li>

        <router-link v-if="!!profile_id && (position !== 'right')" key="profile" :to="{ name: 'my-profile'}" tag="li" active-class="uk-active" class="uk-parent uk-visible-small" exact>
            <a href>{{ profile.name }}</a>

            <div class="uk-dropdown uk-dropdown-navbar">
                <ul class="uk-nav uk-nav-navbar">
                    <li>
                        <a id="tests-logout" @click.prevent="logout">Logout</a>
                    </li>
                </ul>
            </div>
        </router-link>
        <li v-if="!!profile_id&&(position === 'right')" class="uk-parent uk-hidden-small" data-uk-dropdown="{pos:'bottom-right'}">
            <a id="tests-loggedin" href class="uk-navbar-toggle"></a>

            <div class="uk-dropdown uk-dropdown-navbar uk-text-right">
                <ul class="uk-nav uk-nav-navbar">
                    <router-link key="profile-2" :to="{ name: 'my-profile'}" tag="li" active-class="uk-active" exact>
                        <a href>{{ profile.name }}</a>
                    </router-link>
                    <li>
                        <a href="https://docs.google.com/document/d/e/2PACX-1vQsQw74vRFD12xWRe--SqoBp1uoM--FH8v9udPAxVWy3pVjRDqwG9PEs0wy9B6b0GZH9mwLQtYgEQeQ/pub" target="_blank">
                            Help <open-icon glyph="question-circle-o" />
                        </a>
                    </li>
                    <li>
                        <a id="tests-logout" @click.prevent="logout">Logout</a>
                    </li>
                </ul>
            </div>
        </li>
        <!--
        <router-link v-if="(position !== 'left')" key="profile-3" :to="{ name: 'my-profile'}" tag="li" active-class="uk-active" class="uk-parent" data-uk-dropdown exact>
            <a id="tests-loggedin" href="#">{{ profile.name }}</a>

            <div class="uk-dropdown uk-dropdown-navbar">
                <ul class="uk-nav uk-nav-navbar">
                    <li>
                        <a id="tests-logout" @click.prevent="logout">Logout</a>
                    </li>
                </ul>
            </div>
        </router-link>
        <li v-if="(position !== 'left')">
            <a href="https://docs.google.com/document/d/e/2PACX-1vQsQw74vRFD12xWRe--SqoBp1uoM--FH8v9udPAxVWy3pVjRDqwG9PEs0wy9B6b0GZH9mwLQtYgEQeQ/pub" target="_blank">
                <open-icon glyph="question-circle-o" />
            </a>
        </li>
        //-->
    </ul>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex"

import notifies from "../mixins/Notifies"
import profile_utilities from "../mixins/ProfileUtilities"

import OpenIcon from "./OpenIcon"

export default {
    mounted () {
        this.swap_query_context()
    },
    watch: {
        $route: "swap_query_context"
    },
    mixins: [profile_utilities, notifies],
    components: {
        OpenIcon
    },
    methods: {
        create_record (entity) {
            this.$store.dispatch("CREATE_RECORD", {
                entity
            }).then(record => {
                this.$router.push({ name: entity + ".edit", params: { id: record.id } })
            }).catch(error => {
                this.$error(error.message)
            })
        },
        logout () {
            this.$store.dispatch("LOGOUT")
        },
        swap_query_context () {
            if(!!this.$route.meta && !!this.$route.meta.search_entity) this.search_entity = this.$route.meta.search_entity

            const state = this.route_state_by_identifier(this.$route.name)
            this.search = (state && state.search) ? state.search : ""
        },
        changed_search_entity () {
            this.search = ""
            this.$refs.searchbox.focus()
        },
        query () {
            const route = `${this.search_entity}.list`
            const route_state = this.route_state_by_identifier(route) || {}
            route_state.search = this.search
            route_state.include_dead = true
            this.$store.dispatch("SET_ROUTE_STATE", {
                route,
                route_state
            })
            if(this.$route.name !== route) this.$router.push({ name: route, params: { remote: true } })
        }
    },
    computed: {
        ...mapGetters(["route_state_by_identifier"]),
        search_entities () {
            return [
                { id: "project", name: "Projects" },
                { id: "prospective_project", name: "Prospectives" },
                { id: "project_request", name: "RFPs" },
                { id: "firm", name: "Firms" },
                { id: "contact", name: "Contacts" },
                { id: "user", name: "Users" }
            ]
        },
        current_search_entity () {
            return this.search_entities.find(entity => entity.id === this.search_entity).name
        }
    },
    props: [
        "position"
    ],
    data () {
        return {
            search_entity: "project",
            search: ""
        }
    }
}
</script>
